module.exports = __webpack_public_path__ + "static/media/insert_payment.c4bce2b0.jpeg";